import React from "react";
import { Typography } from "@trussle/external-components";
import { ImageDataLike } from "gatsby-plugin-image";
import { IContentfulImage } from "../../types/IContentfulImage";
import "./styles.scss";
import { GatsbyImageOrSvg } from "../../utils/GatsbyImageOrSvg/GatsbyImageOrSvg";

interface IProps {
  classNames?: string;
  title: string;
  url: string;
  image?: IContentfulImage & ImageDataLike;
}

const BigLink: React.FC<IProps> = (props) => {
  const {
    classNames, image, title, url,
  } = props;

  return (
    <a className={`bigLink ${classNames}`} href={url}>
      <div className="bigLink__container">
        {image && (
          <div className="bigLink__imageContainer">
            <GatsbyImageOrSvg image={image} loading="lazy" alt={image.title} />
          </div>
        )}
        <div className="bigLink__titleContainer">
          <Typography variant="h5" classes="bigLink__title">{title}</Typography>
        </div>
        <span className="bigLink__arrow" />
      </div>
    </a>
  );
};

export { BigLink, IProps };
